// extracted by mini-css-extract-plugin
module.exports = {"bgBlue":"Footer_bgBlue__2j_Zd"};